import { Box, Card, Stack, Typography } from '@mui/material';
import { COLOR_BG_SECONDARY, formatForDisplay } from 'shared';

interface PackageCardProps {
  name: string;
  image: string;
  price: number;
}

export const PackageCard = ({ name, image, price }: PackageCardProps) => {
  return (
    <Card className="blur" sx={{ p: 3 }}>
      <Stack direction="row" justifyContent="space-between">
        <Stack>
          <Typography variant="h5" className="primary" mb={3}>
            {name}
          </Typography>

          <Stack mb={2}>
            <Typography variant="body2" className="secondary">
              License Price
            </Typography>
            <Typography variant="h5" className="accent">
              ${formatForDisplay(price, 0, true)}
            </Typography>
          </Stack>
        </Stack>

        <Box
          maxWidth={{ xs: 97, sm: 110, md: 130 }}
          maxHeight={{ xs: 97, sm: 110, md: 130 }}
          borderRadius="50%"
          bgcolor={COLOR_BG_SECONDARY}
          padding="18px"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Box
            component="img"
            alt={`package ${name}`}
            src={image}
            sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </Box>
      </Stack>
    </Card>
  );
};
